/**
 * Buduje siatkę wykreślanki na podstawie słów z API.
 * Obsługuje orientacje: across, down, diag-dr, diag-dl.
 * Puste komórki wypełniane losowymi literami (seed deterministyczny).
 */

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Mulberry32 – seedowalny PRNG
const makeRng = (seed) => {
    let s = typeof seed === 'number' ? seed : hashStr(String(seed));
    return () => {
        s |= 0; s = s + 0x6D2B79F5 | 0;
        let t = Math.imul(s ^ s >>> 15, 1 | s);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
};

const hashStr = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
    return Math.abs(h);
};

// Wektor kierunku dla każdej orientacji
const DIR_VEC = {
    'across':  { dr: 0,  dc: 1  },
    'down':    { dr: 1,  dc: 0  },
    'diag-dr': { dr: 1,  dc: 1  },
    'diag-dl': { dr: 1,  dc: -1 },
};

export const buildWordSearchGrid = (words, seed) => {
    if (!words || words.length === 0) return { grid: [], rows: 0, cols: 0 };

    // Wyznacz rozmiar siatki na podstawie rzeczywistych pozycji słów
    let maxRow = 0;
    let maxCol = 0;

    words.forEach(w => {
        const startR = (w.starty ?? 1) - 1;
        const startC = (w.startx ?? 1) - 1;
        const { dr, dc } = DIR_VEC[w.orientation] ?? DIR_VEC['across'];
        const len = w.answer.length;

        for (let i = 0; i < len; i++) {
            maxRow = Math.max(maxRow, startR + dr * i);
            maxCol = Math.max(maxCol, startC + dc * i);
        }
    });

    const rows = maxRow + 1;
    const cols = maxCol + 1;
    const grid = Array.from({ length: rows }, () => Array(cols).fill(null));

    // Wstaw litery słów
    words.forEach(w => {
        const startR = (w.starty ?? 1) - 1;
        const startC = (w.startx ?? 1) - 1;
        const { dr, dc } = DIR_VEC[w.orientation] ?? DIR_VEC['across'];
        const letters = w.answer.toUpperCase().split('');

        letters.forEach((letter, i) => {
            const r = startR + dr * i;
            const c = startC + dc * i;
            if (r >= 0 && r < rows && c >= 0 && c < cols) grid[r][c] = letter;
        });
    });

    // Wypełnij puste komórki losowymi literami
    const rng = makeRng(seed);
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            if (!grid[r][c]) {
                grid[r][c] = ALPHABET[Math.floor(rng() * ALPHABET.length)];
            }
        }
    }

    return { grid, rows, cols };
};